/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WithdrawInputs */

const th_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถอนทีม`)
};

const en_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw`)
};

const ja_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加を取り消す`)
};

const zh_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出`)
};

const es_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar`)
};

const pt_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar`)
};

const id_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarik diri`)
};

const fr_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer`)
};

const tl_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umatras`)
};

const vi_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rút lui`)
};

const ko_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`철회`)
};

const de_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückziehen`)
};

const ru_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сняться`)
};

const tr_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çekil`)
};

const it_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritirati`)
};

const pl_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wycofaj`)
};

const uk_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Знятися`)
};

const hi_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम वापस लें`)
};

const ar_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الانسحاب`)
};

const ms_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarik diri`)
};

const bn_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রত্যাহার`)
};

const zh_tw2_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出`)
};

const zh_hk2_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出`)
};

const ur_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دستبردار ہوں`)
};

const fa_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انصراف`)
};

const sw_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jitoe`)
};

const nl_withdraw = /** @type {(inputs: WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terugtrekken`)
};

/**
* | output |
* | --- |
* | "Withdraw" |
*
* @param {WithdrawInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const withdraw = /** @type {((inputs?: WithdrawInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WithdrawInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_withdraw(inputs)
	if (locale === "ja") return ja_withdraw(inputs)
	if (locale === "zh") return zh_withdraw(inputs)
	if (locale === "es") return es_withdraw(inputs)
	if (locale === "pt") return pt_withdraw(inputs)
	if (locale === "id") return id_withdraw(inputs)
	if (locale === "fr") return fr_withdraw(inputs)
	if (locale === "tl") return tl_withdraw(inputs)
	if (locale === "vi") return vi_withdraw(inputs)
	if (locale === "ko") return ko_withdraw(inputs)
	if (locale === "de") return de_withdraw(inputs)
	if (locale === "ru") return ru_withdraw(inputs)
	if (locale === "tr") return tr_withdraw(inputs)
	if (locale === "it") return it_withdraw(inputs)
	if (locale === "pl") return pl_withdraw(inputs)
	if (locale === "uk") return uk_withdraw(inputs)
	if (locale === "hi") return hi_withdraw(inputs)
	if (locale === "ar") return ar_withdraw(inputs)
	if (locale === "ms") return ms_withdraw(inputs)
	if (locale === "bn") return bn_withdraw(inputs)
	if (locale === "zh-TW") return zh_tw2_withdraw(inputs)
	if (locale === "zh-HK") return zh_hk2_withdraw(inputs)
	if (locale === "ur") return ur_withdraw(inputs)
	if (locale === "fa") return fa_withdraw(inputs)
	if (locale === "sw") return sw_withdraw(inputs)
	if (locale === "nl") return nl_withdraw(inputs)
	return en_withdraw(inputs)
});